<template>
  <div id="mapdiv" style="width: 100%; height: 100%; position: absolute;">
  </div>
  <controls
      @zoomIn="zoomIn"
      @zoomOut="zoomOut"
      @zoomHome="zoomHome"
      style="position: absolute; right: 10px; top: 10px;"
  ></controls>
  <credits style="position: absolute; right: 0; bottom: 0;"></credits>
<!--  <query-result-->
<!--      v-if="queryResult && queryResultUncertainty"-->
<!--      :values="queryResult ? queryResult.results : ''"-->
<!--      :uncertainty="queryResultUncertainty ? queryResultUncertainty.results : ''"-->
<!--      :layer="layer"-->
<!--  ></query-result>-->
  <query-result
      v-if="queryResult"
      :values="queryResult ? queryResult.results : ''"
      :layer="layer"
  ></query-result>
</template>

<script>
import 'ol/ol.css'
import {Map, View} from 'ol'
import ImageArcGISRest from 'ol/source/ImageArcGISRest'
import { Image as ImageLayer, Vector as VectorLayer} from 'ol/layer'
import { Fill, Stroke } from 'ol/style'
import CircleStyle from 'ol/style/Circle'
import {soilmapUrl, uncertaintymapUrl} from "@/data"
import { get } from 'ol/proj'
import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'
import axios from "axios"
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import {Style} from 'ol/style'
import VectorSource from 'ol/source/Vector'
import Controls from "@/components/Controls";
import QueryResult from "@/components/QueryResult";
import Credits from "@/components/Credits";
import {getBaselayer} from "@/basemap";


export default {
  name: 'Map',
  components: {Credits, QueryResult, Controls},
  data () {
    return {
      map: null,
      view: null,
      mapLayer: null,
      projection: null,
      projectionLV95: null,
      queryResult: null,
      // queryResultUncertainty: null,
      vectorLayer: null,
    }
  },
  methods: {
    zoomOut() {
      this.map.getView().animate({
        zoom: this.map.getView().getZoom() - 1,
        duration: 250
      })
    },
    zoomIn() {
      this.map.getView().animate({
        zoom: this.map.getView().getZoom() + 1,
        duration: 250
      })
    },
    zoomHome() {
      this.map.getView().animate({
        zoom: 5,
        duration: 250
      })
    },
    replacePoint(x, y) {
      if (this.vectorLayer) {
        this.map.removeLayer(this.vectorLayer)
      }
      var iconFeature = new Feature({
        geometry: new Point([x, y]),
        zIndex: 100
      })

      var vectorSource = new VectorSource({
        features: [iconFeature],
        wrapX: false,
      })

      this.vectorLayer = new VectorLayer({
        source: vectorSource,
        zIndex: 10,
        style: new Style({
          image: new CircleStyle({
            radius: 6,
            fill: new Fill({ color: 'red' }),
            stroke: new Stroke({
              color: 'blue',
              width: 3,
            }),
          })
        })
      });
      this.map.addLayer(this.vectorLayer)
    },
    replaceLayer() {
      if (this.mapLayer) {
        this.map.removeLayer(this.mapLayer)
      }

      if(this.layer) {
        this.mapLayer = new ImageLayer({
          source: new ImageArcGISRest({
            ratio: 1,
            params: {'LAYERS': 'show:' + this.layer.id},
            url: this.showUncertaintyLayer ? uncertaintymapUrl.de : soilmapUrl.de,
            crossOrigin: 'anonymous' // avoid CORS error
          }),
          zIndex: 1
        })
      }


      this.map.addLayer(this.mapLayer)
      this.mapLayer.setOpacity(this.opacity / 100)
    },
    setupProjection() {
      proj4.defs('EPSG:21781', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=660.077,13.551,369.344,2.484,1.783,2.939,5.66 +units=m +no_defs')
      proj4.defs('EPSG:2056', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs')
      register(proj4)
      this.projection = get('EPSG:21781')
      this.projectionLV95 = get('EPSG:2056')

    }
  },
  computed: {
    opacity() {
      return this.$store.state.opacity
    },
    layer() {
      return this.$store.state.layer
    },
    showUncertaintyLayer() {
      return this.$store.state.showUncertaintyLayer
    },
    layerGroup() {
      return this.$store.state.layerGroup
    },
    /*token() {
      return this.$store.state.token
    },*/
    currentLanguage() {
      return this.$store.getters.currentLanguage
    }
  },
  mounted() {
    this.emitter.on('removeLayer', (args) => {
      this.map.removeLayer(this.mapLayer)
    })

    this.setupProjection()

    this.view = new View({
      projection: this.projection,
      center: [652160, 155800],
      resolution: 350,
      maxZoom: 14,
      minZoom: 5,
      extent: [300000, 0, 1000000, 400000]
    })

    this.map = new Map({
      target: 'mapdiv',
      controls: [],
      layers: [getBaselayer(this.projection)],
      view: this.view
    })

    this.map.on('singleclick', (evt) => {
      if (!this.layer || this.layerGroup == null) return

      let viewResolution = this.view.getResolution()
      let screenWidth = this.map.getViewport().clientWidth
      let screenHeight = this.map.getViewport().clientHeight
      let extent = this.map.getView().calculateExtent()
      let geomType = 'esriGeometryPoint'
      let layerIds
      // Soil depth is the only non-group layers
      if(this.layerGroup.id) {
        layerIds = this.layerGroup.id
      } else {
        layerIds = this.layerGroup.subLayers.map(sl => sl.id).join(',')
      }

      const params = {
        geometry: evt.coordinate[0] + ','  + evt.coordinate[1],
        geometryType: geomType,
        sr: 21781,
        layers: 'all:' + layerIds,
        tolerance: 10,
        mapExtent: extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3],
        imageDisplay: screenWidth + ',' + screenHeight + ',' + viewResolution,
        f: 'pjson'
      }

      this.replacePoint(evt.coordinate[0], evt.coordinate[1])

      let serviceUrl = soilmapUrl.de + '/identify'

      if(this.currentLanguage == 0) {
        serviceUrl = soilmapUrl.de + '/identify'
      } else if (this.currentLanguage == 1)  {
        serviceUrl = soilmapUrl.fr + '/identify'

      } else if (this.currentLanguage == 2) {
        serviceUrl = soilmapUrl.en + '/identify'
      }

      axios.get(serviceUrl, { params })
        .then(res => {
          this.queryResult = res.data
        })

      // axios.get(uncertaintymapUrl + '/identify', { params })
      //     .then(res => { console.log(res.data); this.queryResultUncertainty = res.data})
    });


  },
  watch: {
    opacity() {
      if (this.mapLayer) {
        this.mapLayer.setOpacity(this.opacity / 100)
      }
    },
    layer: {
      handler() {
        this.replaceLayer()
      },
      deep: true
    },
    layerGroup: {
      handler() {
        // this.queryResultUncertainty = null
        this.queryResult = null
        this.map.removeLayer(this.vectorLayer)
      },
      deep: true
    },
    showUncertaintyLayer() {
      this.replaceLayer()
    }
  }
}
</script>

<style scoped>

</style>
